module.exports = "<section class=\"nn-base-swiper swiper-container\"><div ng-transclude class=\"nn-base-swiper__wrapper swiper-wrapper\"></div><div class=\"nn-base-swiper__nav swiper-arrows\" ng-style=\"{ top: arrowsTop }\" ng-show=showArrows><a ng-show=true class=\"prev js-prev\" href><i class=icon-prev></i></a> <a ng-show=true class=\"next js-next\" href><i class=icon-next></i></a></div></section>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-base-components/nn-base-swiper/nn-base-swiper.directive.html
// module id = 961
// module chunks = 0